import React, {Fragment} from 'react';
import Newsletter from 'components/newsletter/Newsletter';
import GetApp from 'components/getApp/GetApp';
import Footer from 'components/footer';
import NewsletterStore from 'components/newsletter/NewsletterStore';
import getAppStore from 'components/getApp/GetAppStore';
import footerStore from 'components/footer/FooterStore';

const FooterSection = () => (
  <>
    {!footerStore.isAffiliate && <Newsletter store={NewsletterStore} />}
    {getAppStore.isAirtickets && <GetApp store={getAppStore} />}
    <Footer store={footerStore} />
  </>
);

export default FooterSection;
